import { useState } from 'react';

import { Container, Typography } from '@mui/material';

import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TCoreNursingSkillVideoDefaultValues as TCoreNursingSkillVideoDeExemplefaultValues,
} from 'routes/Main/Survey/type';

import StudentModeInfoExemple from './StudentModeInfoExemple';

const CoreNursingSkillVideoExempleFour = (
  props: SurveyDialogProps<TCoreNursingSkillVideoDeExemplefaultValues>
) => {
  const { title, isOpen, onClose } = props;

  return (
    <MuiDialog.SurveyFormTwo title={title} isOpen={isOpen} onClose={onClose}>
      <Container sx={{ mt: 6, mb: 6 }}>
        <Typography
          sx={{ margin: '0 0 30px 0', fontSize: '20px', fontWeight: 700 }}
        >
          핵심간호술기영상 예시4 (대한나래출판사)
        </Typography>
        <StudentModeInfoExemple />
      </Container>
    </MuiDialog.SurveyFormTwo>
  );
};

export default CoreNursingSkillVideoExempleFour;
